export default (path) => path === '/user' || path.startsWith('/user/');
